module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('button', {
    class: {
      'ready color-bg-primary': _vm.loaded, 'color-base-text': !_vm.loaded
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loaded) ? _c('span', {
    key: "loaded",
    staticClass: "label loaded",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonLabel)
    }
  }) : _c('span', {
    key: "loading",
    staticClass: "label loading",
    domProps: {
      "innerHTML": _vm._s(_vm.buttonLabel)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress"
  }, [_c('span', {
    staticClass: "indicator",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7472f74b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressButton.vue
// module id = 468
// module chunks = 1